/** Formato monetario en EUR con coma decimal (es-ES). */

/**
 * @param {number} n
 * @returns {string} ej. "39,00"
 */
export function formatAmount(n) {
  return Number(n ?? 0).toFixed(2).replace(".", ",");
}

/**
 * @param {number} n
 * @returns {string} ej. "39,00 €"
 */
export function formatEur(n) {
  return `${formatAmount(n)} €`;
}
